import { BannerSearchDto } from '../../shared/dto/banner-search.dto';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wl-banner-ad-search-params',
  templateUrl: './banner-ad-search-params.component.html',
  styleUrls: ['./banner-ad-search-params.component.less'],
    standalone: false
})
export class BannerAdSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: BannerSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange: EventEmitter<BannerSearchDto> = new EventEmitter();

  private _searchParams: BannerSearchDto;

  constructor() {
    this.searchParams = new BannerSearchDto();
  }

  ngOnInit(): void {}
}
